<template>
  <div class="custom-container">
    <div class="ms-cell-editor number" :class="{'cell-error': errorMessage}">
      <div
        class="flex-row flex show-value"
        v-show="!isSelected || readOnly || !editable"
        :class="{
          'edit-disabled': readOnly,
          'ms-editor-text': editable,
          hasError: errorProvider.isValid,
          'display-error': errorMessage && !isEditor && displayError,
        }"
        key="show"
        :title="errorProvider.message"
      >
        <a v-show="!isEditor" @click="$emit('editorClick', $event, col, colIndex)" class="editor-click">
          <span
            class="editor-display text-right"
            :class="propsData?.align ? propsData?.align : ''"
            :title="
              customTitle && customTitle[col.dataField]
                ? customTitle[col.dataField]
                : [
                    dataRow[col.dataField]
                      ? $ms.format.formatData(dataRow[col.dataField], {
                          formatType:
                            customControlType && dataRow._customType
                              ? dataRow._customType[col.dataField]
                              : col.formatType,
                        })
                      : '',
                  ]
            "
            >{{
              dataRow[col.dataField]
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType:
                      customControlType && dataRow._customType ? dataRow._customType[col.dataField] : col.formatType,
                  })
                : ''
            }}</span
          >
          <!-- NOTE NXCHIEN 04.01.2023 formatType luôn lấy theo col.formatType -->
        </a>

        <ms-number
          v-model="cellData"
          v-if="isEditor"
          v-on="listeners"
          :max="propsData.max"
          :min="propsData.min"
          :align="propsData.align"
          :decimalPlaces="
            customControlType && dataRow._decimalPlaces
              ? dataRow._decimalPlaces[col.dataField]
              : propsData.decimalPlaces
          "
          :formatType="customControlType && dataRow._customType ? dataRow._customType[col.dataField] : col.formatType"
          :allowDigitGroupSeparator="propsData.allowDigitGroupSeparator"
          :preventPaste="allowCopyFromExcel"
          ref="msNumber"
        >
        </ms-number>
        <!-- NOTE NXCHIEN 04.01.2023 decimalPlaces luôn lấy theo propsData.decimalPlaces -->
        <!-- NOTE NXCHIEN 04.01.2023 formatType luôn lấy theo col.formatType -->
        <div class="icon24 error" v-tooltip="errorMessage" v-show="errorMessage && !isEditor && displayError"></div>
      </div>
    </div>

    <v-menu
      ref="optionMenu"
      class="option-wrapper"
      v-if="isEditor && isCopyDataColumn"
      popperClass="option-menu"
      :placement="isAtLastColumn ? 'bottom-start' : 'bottom-end'"
      :skidding="marginSetting"
      :width="menuContentWidth"
      :style="[{right: isAtLastColumn ? 'auto' : optionMenuRight}, {left: isAtLastColumn ? optionMenuLeft : 'auto'}]"
      @show="handleMenuShow"
      :class="dbOptionHeight"
    >
      <div :class="['icon24', 'option-tab-vertical', 'option-custom']"></div>
      <template #popper>
        <menu-item
          v-for="(item, i) in editorActions"
          :key="i"
          @menu-item-click="clickMenuItem(item.id, rowIndex, colIndex)"
          >{{ item.text }}</menu-item
        >
      </template>
    </v-menu>
  </div>
</template>
<script>
import {defineProps, ref, defineEmits, watch, nextTick, defineExpose, getCurrentInstance, computed, inject} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
export default {
  name: 'MsCellNumber',
  components: {
    MenuItem,
  },
  emits: ['update:modelValue', 'editorClick', 'msKeydown', 'copyActionClick', 'pasteInput'],
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    //Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },

    readOnly: {
      default: false,
      type: Boolean,
    },
    //có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Array,
      default: () => [],
    },
    /**
     * Biến này ko đưuọc phép dùng
     * NXCHIEN 04.01.2022
     */
    customControlType: {
      default: false,
      type: Boolean,
    },
    customTitle: {
      default: null,
      type: Object,
    },
    /**
     * Cấu hình sao chép dữ liệu 1 cột xuống các cột khác (mục đích để dev phải check lại các màn hình đã làm để tránh lỗi dữ liệu)
     * dtnga3 (26.05.2023)
     */
    isCopyDataColumn: {
      default: false,
      type: Boolean,
    },
    optionMenuRight: {
      default: null,
      type: String,
    },
    optionMenuLeft: {
      default: null,
      type: String,
    },
    // Đánh dấu control nằm ở cột cuối hay không
    // dtnga3
    isAtLastColumn: {
      default: false,
      type: Boolean,
    },
    // Độ rộng menu content (cần set để tính toán vị trí của nó)
    // dtnga3
    menuContentWidth: {
      default: 194,
      type: Number,
    },
  },

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      clearValidate,
      getValue,
      displayError,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
    } = useCellEditor({
      emit,
      props,
    });
    watch(isEditor, (newVal, oldValue) => {
      if (!newVal) {
        emit('update:modelValue', cellData.value);
      } else {
        cellData.value = props.dataRow[props.col.dataField];
        nextTick(() => {
          findEditor();
        });
      }
    });

    const col = props.col;
    const rowIndex = props.rowIndex;
    const colIndex = props.colIndex;
    const isCellEditor = inject('isCellEditor');
    const allowCopyFromExcel = inject('allowCopyFromExcel');
    const dbOptionHeight = computed(() => {
      return (
        'heightoptionvalue' +
        parseInt(
          proxy.$store?.state?.dbOption?.dbOptions.HeightOption == 1
            ? proxy.$store?.state?.dbOption?.dbOptions.HeightOption
            : 0,
        )
      );
    });

    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (typeof isCellEditor == 'function' && !isCellEditor(col, props.dataRow)) {
        return;
      }

      if (me.readOnly) {
        return;
      }

      if (isNaN(value)) {
        value = 0;
      }

      value = Math.round(parseFloat(value));

      if (value > (me.propsData?.max || 99999999999999)) {
        value = 0;
      }

      if (value < (me.propsData?.min || -99999999999999)) {
        value = 0;
      }

      if (isEditor.value && typeof me.$refs.msNumber?.setValue == 'function') {
        me.$refs.msNumber.setValue(value);
      }

      cellData.value = value;
      emit('update:modelValue', cellData.value);
    };

    return {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      clearValidate,
      getValue,
      displayError,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
      dbOptionHeight,
      setValue,
      allowCopyFromExcel,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/CellAction.scss';
.editor-display {
  flex: 1;
  padding: 0 6px;
  &.center{
    text-align: center;
  }
}
</style>
